import type { FFEDocument } from '../../types/ffe'
import { generateCSV } from './core'
import { getLineItemColumns } from './lineItems'
import { getMaterialColumns } from './materials'

export const exportDocumentToCSV = (document: FFEDocument) => {
  // Export line items
  generateCSV(document.lineItems, getLineItemColumns(document.materials), {
    filename: `${document.title}-items.csv`
  })

  // Export materials
  generateCSV(document.materials, getMaterialColumns(), {
    filename: `${document.title}-materials.csv`
  })
}
